
const router = [
  {
    name: 'data',
    path: '/data',
    meta: {
      title: '数据处理',
      icon: 'shezhi'
    }
  },
  {
    name: 'dataBanner',
    path: '/data/banner',
    component: () => import('/@/views/data/banner/Banner.vue'),
    meta: { title: '幻灯片' }
  },
  {
    name: 'dataArticle',
    path: '/data/article',
    component: () => import('/@/views/data/article/Article.vue'),
    meta: { title: '文章模块' }
  },
  {
    name: 'dataHelp',
    path: '/data/help',
    component: () => import('/@/views/data/help/Help.vue'),
    meta: { title: '帮助文档' }
  },
  {
    name: 'dataFriends',
    path: '/data/friends',
    component: () => import('/@/views/data/friends/Friends.vue'),
    meta: { title: '友情链接' }
  },
  {
    name: 'dataAdvert',
    path: '/data/advert',
    component: () => import('/@/views/data/advert/Advert.vue'),
    meta: { title: '广告模块' }
  },
  {
    name: 'dataMessage',
    path: '/data/message',
    component: () => import('/@/views/data/Message.vue'),
    meta: { title: '留言数据' }
  }
]
export default router
